import { Component, inject } from "@angular/core";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { FormsModule } from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { MatCardModule } from "@angular/material/card";
import { MatDialog } from "@angular/material/dialog";
import { NewContractDialogComponent } from "projects/dora/src/app/features/home/ui/new-contract/new-contract-dialog/new-contract-dialog.component";
import { SubscriptionOverviewService } from "../home/data-access/subscription-overview.service";
import { PromptingViewComponent } from "./ui/prompting-view/prompting-view.component";
import { WorkflowOverviewService } from "../home/data-access/workflow-overview.service";
import { ProcessService } from "@shared-api/process/process.service";

export interface DialogData {
  workflowName: string;
}

@Component({
  selector: "prompt-testing",
  standalone: true,
  imports: [
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    MatCardModule,
    PromptingViewComponent,
  ],
  templateUrl: "./prompt-testing.component.html",
  styleUrl: "./prompt-testing.component.scss",
  providers: [
    {
      provide: WorkflowOverviewService,
      useClass: WorkflowOverviewService,
      deps: [],
    },
    {
      provide: ProcessService,
      useClass: ProcessService,
      deps: [],
    },
  ],
})
export class PromptTestingComponent {
  subscriptionOverview = inject(SubscriptionOverviewService);
  selectedWorkflowId: string | undefined = undefined;
  dora_logo = "/assets/img/intro.png";
  deleteMode: boolean = false;
  workflowName: string | undefined;

  constructor(public dialog: MatDialog) {}

  ngOnInit(): void {
    this.subscriptionOverview.getSubscriptionData$.next();
  }

  createNewWorkflow(workflowName: string): void {
    this.subscriptionOverview.createNewPrompt$.next(workflowName);
  }

  deleteWorkflow(workflowId: string): void {
    if (this.selectedWorkflowId == workflowId) {
      this.selectedWorkflowId = undefined;
    }
    this.subscriptionOverview.deleteWorkflowId$.next(workflowId);
  }

  openWorkflow(workflowId: string): void {
    if (this.selectedWorkflowId != workflowId) {
      this.selectedWorkflowId = workflowId;
    }
  }

  newWorkflow(): void {
    let dialogRef = this.dialog.open(NewContractDialogComponent, {
      height: "fit-content",
      width: "max(200px, 400px)",
      data: { name: this.workflowName },
    });

    dialogRef.afterClosed().subscribe((workflowName: string) => {
      if (workflowName) {
        this.createNewWorkflow(workflowName);
      }
    });
  }
}
